import { md5 } from "js-md5";

export type Tool = 'GAMEFACE' | 'GREAT_MINDS' | 'PACT' | 'LOOPED_IN' ;


export class User {

  id?: string ;
  givenName: string ;
  familyName: string ;
  email: string;
  profileImage?: string ;
  bio?: string;
  
  constructor(id: string | undefined, givenName: string, familyName: string, email: string) {
    this.id = id;
    this.givenName = givenName ;
    this.familyName = familyName ;
    this.email = email;    
  }
}


export interface ContractStatus {
  underContract: boolean;
  tools: Tool[];
  endsAt: Date | null;
}


export function getUsername(email: string): string {
  return md5(email.trim().toLowerCase());
}